/**
 * Vue2 main App init.
*/
import Vue from 'vue';
import VueMatomo from 'vue-matomo';
import App from '@/App.vue';
import router from '@/router/index.js';
import { BasePlugins, LazyPlugins } from '@/plugins/index.js';
import GmapVue from 'gmap-vue';
import { getGoogleMapsAPI } from 'gmap-vue';
// global Vue config
// ====================================
Vue.config.productionTip = false;
Vue.config.performance = false;
Vue.config.ignoredElements = [
    /^icon-/,
    'vue-agile'
];
process.client = true;


// install plugins to global Vue scope
// ====================================
Vue.use(BasePlugins);


// collect global properties from the plugins
// ====================================
const {
    i18n,
    store
} = BasePlugins.globalProperties;


// create app instance
// ====================================
export const app = new Vue({
    el: '#app',
    router,
    i18n,
    store,
    components: { App },
    template: '<App/>'
});


// mount app and load async plugins
// ====================================
router.onReady(() => {
    app.$mount('#app');
    Vue.use(
        LazyPlugins,
        BasePlugins.globalProperties
    );
});

// Listen for route changes and send page view events to Matomo
router.afterEach((to, from) => {
    window._paq.push(['trackPageView', to.fullPath]);
   // Vue.$matomo.trackPage(to.fullPath);
});



Vue.use(GmapVue, {
    load: {
      // [REQUIRED] This is the unique required value by Google Maps API
      key: 'AIzaSyAhiNXd547vAbysPgPQ9SL26eLmTGcIaGY',
      // [OPTIONAL] This is required if you use the Autocomplete plugin
      // OR: libraries: 'places,drawing'
      // OR: libraries: 'places,drawing,visualization'
      // (as you require)
      libraries: 'places',
      // [OPTIONAL] If you want to set the version, you can do so:
      //v: '3.26',

      // This option was added on v3.0.0 but will be removed in the next major release.
      // If you already have an script tag that loads Google Maps API and you want to use it set you callback
      // here and our callback `GoogleMapsCallback` will execute your custom callback at the end; it must attached
      // to the `window` object, is the only requirement.
      //customCallback: 'MyCustomCallback',
    },

    // [OPTIONAL] If you intend to programmatically custom event listener code
    // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    // you might need to turn this on.
    autoBindAllEvents: false,

    // [OPTIONAL] If you want to manually install components, e.g.
    // import {GmapMarker} from 'gmap-vue/src/components/marker'
    // Vue.component('GmapMarker', GmapMarker)
    // then set installComponents to 'false'.
    // If you want to automatically install all the components this property must be set to 'true':
    installComponents: true,

    // Load the Google Maps API dynamically, if you set this to `true` the plugin doesn't load the Google Maps API
    dynamicLoad: false,
  })

export default {
    app
}
//export default app;
